@if (description() && title()) {
  <h1 class="text-2xl font-bold mb-2">{{ title() }}</h1>
  <p *ngIf="description() !== ''" class="text-base mb-2 line-clamp-3">{{ description() }}...</p>
  <p *ngIf="description() !== ''" class="text-base"><span (click)="onMoreClick()" class="underline cursor-pointer">Läs mer</span>
  </p>
}
